import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

import testimonialImg1 from "../assets/images/client/testimonial-1.jpg";
import testimonialImg2 from "../assets/images/client/testimonial-2.jpg";
import testimonialImg3 from "../assets/images/client/testimonial-3.jpg";
import testimonialImg4 from "../assets/images/client/testimonial-4.jpg";
import testimonialImg5 from "../assets/images/client/testimonial-5.jpg";
import testimonialImg6 from "../assets/images/client/testimonial-6.jpg";
import testimonialImg7 from "../assets/images/client/testimonial-7.jpg";
import testimonialImg8 from "../assets/images/client/testimonial-8.jpg";

const testimonials = [
  {
    quote:
      "Super fast work, fulfills what was promised, it is easy to understand the purpose of the project. We will certainly work together again. Thank you, I was very pleased with the result. I hope that we can do new projects together.",
    author: "Mauro",
    image: testimonialImg1,
  },
  {
    quote:
      "Stepped in at a time when the project needed an expert hand to complete the work. I couldn't have asked for more than he delivered.",
    author: "Neil",
    image: testimonialImg2,
  },
  {
    quote: "Fast, efficient and Nice. All you ever wanted! This freelancer clearly loves his work, and as a client, you can feel it in the communication and see it in the quality of his result. Thank you",
    author: "Andrea",
    image: testimonialImg3,
  },
  {
    quote: "As usual, project delivered on time and on budget...........very good guy to work with...this is about the 5th project he's done for me, and i am just as satisfied as before. I will rehire him",
    author: "Francis",
    image: testimonialImg4,
  },
  {
    quote: "This Freelancer is now my GO TO MAN! Any Website or Forum projects that I need done in the future, Uxdev gets first looks at it! Good Job mate!",
    author: "Blayn",
    image: testimonialImg5,
  },
  {
    quote: "Good Work.",
    author: "Cesar",
    image: testimonialImg6,
  },
  {
    quote: "Thanks again. Great freelancer to work with. Absolutely recommend",
    author: "Faz",
    image: testimonialImg7,
  },
  {
    quote:
      "Great Job. Delivered exactly what I needed",
    author: "Paul",
    image: testimonialImg8,
  },
];

const Testimonial = () => (
  <div className="row">
    <div className="col-lg-12">
      <Tabs>
        {testimonials.map((testimonial) => (
          <TabPanel key={testimonial.author}>
            <div className="rn-testimonial-content text-center">
              <div className="inner">
                <p>{testimonial.quote}</p>
              </div>
              <div className="author-info">
                <h6>{testimonial.author}</h6>
              </div>
            </div>
          </TabPanel>
        ))}

        <TabList className="testimonial-thumb-wrapper">
          {testimonials.map((testimonial) => (
            <Tab key={testimonial.author}>
              <div className="testimonial-thumbnai">
                <div className="thumb">
                  <img src={testimonial.image} alt={`${testimonial.author} testimonial`} />
                </div>
              </div>
            </Tab>
          ))}
        </TabList>
      </Tabs>
    </div>
  </div>
);

export default Testimonial;
